<style lang="sass" scoped>
@import "../../../../../css/core";

.-shortage {
  color: $color-red;
  font-weight: bold;
}
</style>


<template>
<div class="reservations-table-staff-capacities-body">
  <div class="-row" v-bind:style="rowStyle">
    <div
        v-for="r in resourceSequence"
        class="-cell"
        v-bind:class="{'-shortage': r.staffRemains < 0}"
        v-bind:style="cellStyleByTick(r.tick)"
        @mouseover="$dispatch('tick-over', r.tick)"
        @mouseout="$dispatch('tick-out', r.tick)"
    >{{ r.staffRemains }}</div>
  </div>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'reservations-table-staff-capacities-body',
  mixins: [require('../body.vue')],
  props: {
    resourceSequence: {
      type: Array,
      required: true,
    },
  },
  computed: {
    cellStyle() {
      return Object.assign({}, this._cellStyle, {
        'text-align': 'center',
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// body.vue?06388ec6